var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.loading)?_c('div',{staticClass:"text-center font-weight-bold"},[_vm._v(_vm._s(_vm.value)+" ngày")]):_c('div',{staticClass:"text-center"},[_c('v-progress-circular',{attrs:{"indeterminate":"","color":"primary"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }